import StimulusSortable from '@stimulus-components/sortable'
import Sortable from 'sortablejs'

export default class extends StimulusSortable {
  static targets = ['container', 'item']

  static values = {
    containerSelector: String,
    filter: { default: '.sortable--no-drag', type: String },
    preventOnFilter: { default: true, type: Boolean },
  }

  connect() {
    const containerElement =
      this.hasContainerTarget ? this.containerTarget : this.element

    this.sortable = new Sortable(containerElement, {
      ...this.defaultOptions,
      ...this.options,
    })

    this.updatePositions()
  }

  onUpdate(event) {
    super.onUpdate?.(event)
    this.updatePositions()
  }

  updatePositions() {
    this.itemTargets.forEach((item, index) => {
      const localItem = item
      const input =
        item.querySelector('[data-position-input]') ||
        item.querySelector('input[name$="[position]"]')

      if (input) {
        const position = index + 1
        input.value = position
        localItem.dataset.position = position
      }
    })

    this.dispatch('reindexed', { detail: { count: this.itemTargets.length } })
  }

  get defaultOptions() {
    return {
      filter: this.filterValue,
      forceFallback: true,
      preventOnFilter: this.preventOnFilterValue,
      scroll: true,
      scrollSensitivity: 150,
    }
  }
}
